import { now } from "moment/moment";
import Cookie from "universal-cookie";

class CookiesServices {
  constructor() {
    this.cookie = new Cookie();
  }

  get(key) {
    return this.cookie.get(key);
  }

  set(key, value, options) {
    return this.cookie.set(key, value, options);
  }

  remove(key, options) {
    return this.cookie.remove(key, options);
  }

  // Remove ALL cookies (accessible via JavaScript)
  removeAllCookies() {
    const allCookies = this.cookie.getAll();
    Object.keys(allCookies).forEach((key) => {
      this.remove(key, { path: '/' });
    });
  }

  // eProfile
  setProfileStatus(profile) {
    const hasProfile = profile !== null;
    this.set('hasProfile', String(hasProfile), { path: '/' });
  }

  hasProfile() {
    return this.get('hasProfile') === 'true';
  }

  // TEMP KPI values (used before fetch)
  setTempKpi(user, mode) {
    this.set('tempKpiUser', user, { path: '/' });
    this.set('tempKpiMode', mode, { path: '/' });
  }

  getTempKpi() {
    return {
      user: this.get('tempKpiUser'),
      mode: this.get('tempKpiMode'),
    };
  }

  clearTempKpi() {
    this.remove('tempKpiUser', { path: '/' });
    this.remove('tempKpiMode', { path: '/' });
  }

  // Save selected role/subrole state for restoration
  setSubroleData({ searchValueForRole, searchValueForSubrole, subroles, selectedRoleOrder }) {
    if (searchValueForRole) this.set('searchValueForRole', searchValueForRole, { path: '/' });
    if (searchValueForSubrole) this.set('searchValueForSubrole', searchValueForSubrole, { path: '/' });
    if (Array.isArray(subroles)) this.set('subroles', JSON.stringify(subroles), { path: '/' });
    if (selectedRoleOrder) this.set('selectedRoleOrder', selectedRoleOrder, { path: '/' });
  }

  getSubroleData() {
    return {
      searchValueForRole: this.get('searchValueForRole') || '',
      searchValueForSubrole: this.get('searchValueForSubrole') || '',
      selectedRoleOrder: this.get('selectedRoleOrder') || '',
      subroles: (() => {
        try {
          return JSON.parse(this.get('subroles') || '[]');
        } catch {
          return [];
        }
      })()
    };
  }

  clearSubroleData() {
    ['searchValueForRole', 'searchValueForSubrole', 'subroles', 'selectedRoleOrder']
      .forEach(key => this.remove(key, { path: '/' }));
  }

  // Check if all required cookies are present; if not, reload
  validateLogin() {
    const requiredKeys = [
      "AccessToken",
      "UserName",
      "Level",
      "code",
      "name",
      "branch",
      "kpiUser",
      "kpiMode",
      "session_state"
    ];

    const missingKey = requiredKeys.find(key => {
      const value = this.get(key);
      return value === undefined || value === null || value === '';
    });

    if (missingKey) {
      console.warn(`Missing or invalid cookie: ${missingKey}. Reloading...`);
      this.clearLogin();
      window.location.href = `${process.env.REACT_APP_LOGIN_URL}`;
    }
  }

  async saveLoginDetailsFromUrl() {
    var loginSuccess = false;
    const params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var sessionState = params.get('session_state');

    if (!code || !sessionState) {
      sessionState = this.get('session_state');
      code = this.get('code');
      if (code && sessionState) {
        if (Number(this.get("errorCode")) === 2) {
        return false;
    }
        return true;
      }
    }

    if (code && sessionState) {
      try {
        const data = await this.loginUser({ userName: code, password: sessionState });
        console.log("saveLoginDetailsFromUrl");
        const expirationDate = new Date(Date.now()); // 1 hour
        expirationDate.setDate(expirationDate.getDate() + 1);

        if (data.errorCode === 2) {

          this.set('errorCode', String(data.errorCode), {
            path: '/',
            expires: expirationDate
          });

          this.set('errorMessage', data.errorMessage || "Login failed", {
            path: '/',
            expires: expirationDate
          });

          this.remove('AccessToken', { path: '/' });
          this.remove('UserName', { path: '/' });


          return false;
        }


        if (data.errorCode === 3) {

          this.set('errorCode', String(data.errorCode), {
            path: '/',
            expires: expirationDate
          });

          this.set('errorMessage', data.errorMessage || "", {
            path: '/',
            expires: expirationDate
          });

          // Continue saving AccessToken, UserName, kpiMode, kpiUser
        }

        if (Number(data.errorCode) === 1) {
          this.set('errorCode', data.errorCode, {
            path: '/',
            expires: expirationDate
          });

          this.set('errorMessage', data.errorMessage || "", {
            path: '/',
            expires: expirationDate
          });
        }

        if (data.accessToken && data.level) {
          this.set('AccessToken', data.accessToken, { path: '/', expires: expirationDate });
          this.set('Level', data.level, { path: '/', expires: expirationDate }); // Save agent_Rank
                    this.set('code', data.code, { path: '/', expires: expirationDate  }); // Save agent_code
                    this.set('UserName', data.username, { path: '/', expires: expirationDate  }); // Temp fix
                    this.set('name',data.name, { path: '/', expires: expirationDate }); // Save agent_name
                    this.set('branch',data.branch, { path: '/', expires: expirationDate }); // Save agent_branch_name
                    this.set('searchByAgent','', { path: '/', expires: expirationDate });
                    this.set('kpiMode',data.kpiMode, { path: '/', expires: expirationDate });
                    this.set('kpiUser',data.kpiUser, { path: '/', expires: expirationDate });
                    this.set('designationName',data.designationName, { path: '/', expires: expirationDate});
                    this.set('designationCode',data.designationCode, { path: '/', expires: expirationDate});
                    this.set('peopleName',data.peopleName, { path: '/', expires: expirationDate });
                    this.set('peopleCode',data.peopleCode, { path: '/', expires: expirationDate });
                    this.set('role',data.role, { path: '/', expires: expirationDate });
                    this.setImpersonationUsers(data.impersonation || []);
                    this.set('level_category', data.level_category, { path: '/', expires: expirationDate });
                    if (Number(data.errorCode) > 0) {
                      this.set('errorCode', String(data.errorCode), {
                        path: '/',
                        expires: expirationDate
                    });

                      this.set('errorMessage', data.errorMessage || "", {
                        path: '/',
                        expires: expirationDate
                    });
                    } else {
                      this.remove('errorCode', { path: '/' });
                      this.remove('errorMessage', { path: '/' });
                    }
          //Here is the URL data
          this.set('session_state', sessionState, { path: '/' });
          //this.set('UserName', code, { path: '/' }); // Save code as UserName
          this.set('hierarchy', JSON.stringify(data.hierarchy), { path: '/' });
          this.setProfileStatus(data.profile);
          // Save level list & default selected level
          if (Array.isArray(data.levels)) {
            this.set("levels", JSON.stringify(data.levels), { path: "/", expires: expirationDate });

            // Store default level (first one)
            const defaultLevel = data.levels[0];
            if (defaultLevel) {
              this.setSelectedLevel(defaultLevel);
            }
          }

          if (Number(data.errorCode) === 3) {
  
    return false;
}

// Normal login validation
this.validateLogin();

          loginSuccess = true;
        } else {
          this.clearLogin();
        }
        //If there is login error remove cookie details
      } catch (error) {
        console.error("Login error:", error);
        this.clearLogin();
      }
    }
    return loginSuccess;
  }

  setImpersonationUsers(users) {
    const impersonationUsers = users || [];

    this.set('impersonationUsers', JSON.stringify(impersonationUsers), {
      path: '/'
    });

    this.set('impersonationCount', impersonationUsers.length, {
      path: '/'
    });

    if (impersonationUsers.length === 1) {
      this.set('ImpersonatedUser', impersonationUsers[0].kpiUser, {
        path: '/'
      });
    } else {
      this.remove('ImpersonatedUser', {
        path: '/'
      });
    }
  }

  getImpersonatedUser() {
    return this.get('ImpersonatedUser') || '';
  }

  getImpersonationUsers() {
    try {
      return JSON.parse(this.get('impersonationUsers') || '[]');
    } catch {
      return [];
    }
  }

  getImpersonationCount() {
    const val = this.get('impersonationCount');
    return val ? Number(val) : 0;
  }

  clearImpersonationUsers() {
    this.remove('impersonationUsers', { path: '/' });
    this.remove('impersonationCount', { path: '/' });
    this.remove('ImpersonatedUser', { path: '/' });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json',
      'AuthenticationToken': this.get('AccessToken') || '',
      'UserName': this.get('UserName') || '',
      'Level': this.get('Level') || '',
      'KpiMode': this.get('kpiMode') || '',
      'KpiUser': this.get('kpiUser') || '',
      'ImpersonatedUser': this.get('ImpersonatedUser') || '',
      'FilterMode': 'USER',
    };
  }

  getHeadersFormData() {
    return {
      // 'Content-Type': 'multipart/form-data',
      'AuthenticationToken': this.get('AccessToken') || '',
      'UserName': this.get('UserName') || '',
      'Level': this.get('Level') || '',
      'KpiMode': this.get('kpiMode') || '',
      'KpiUser': this.get('kpiUser') || '',
      'ImpersonatedUser': this.get('ImpersonatedUser') || '',
      'FilterMode': 'USER',
    };
  }


  toUrl(version, endpoint) {
    if (version === 'v1') {
      return `${process.env.REACT_APP_API_URL}${endpoint}`;
    }

    if (version === 'v2') {
      // ToDo: Update when v2 API is ready
    }

    throw new Error(`Unsupported API version: ${version}`);
  }

  // Clear all login-related cookies
  clearLogin() {
    const keys = [
      "code",
      "session_state",
      "AccessToken",
      "UserName",
      "Level",
      "branch",
      "name",
      "searchByAgent",
      "hierarchy",
      "kpiUser",
      "kpiMode",
      "tempKpiUser",
      "tempKpiMode",
      "searchValueForRole",
      "searchValueForSubrole",
      "subroles",
      "selectedRoleOrder",
      "designationName",
      "designationCode",
      "peopleName",
      "peopleCode",
      "password",
      "hasProfile"
    ];
    keys.forEach((key) => this.remove(key, { path: "/" }));
  }

  async loginUser(credentials) {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/login/user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.error("401 Unauthorized. Clearing cookies and redirecting to login.");
        this.clearLogin();
        window.location.href = `${process.env.WINDOW_LOCATION_HREF}`;
        return;
      }

      if (response.status === 500) {
        console.error("500 Internal Server Error. Clearing cookies.");
        this.clearLogin();
        alert("Server error. Please try again later");
        return;
      }

      const errorData = await response.json();
      throw new Error(errorData.errorMessage || 'Failed to fetch user details');
    }

    return response.json();
  }

  // Save selected level from dropdown
  setSelectedLevel(kpi) {
    if (!kpi) return;

    const expirationDate = new Date(Date.now() + 10 * 60 * 1000); // 10 mins
    if (kpi.user) this.set("kpiUser", kpi.user, { path: "/", expires: expirationDate });
    if (kpi.mode) this.set("kpiMode", kpi.mode, { path: "/", expires: expirationDate });
  }

  // Get selected level object from cookies
  getSelectedLevel() {
    return {
      user: this.get("kpiUser"),
      mode: this.get("kpiMode"),
    };
  }

  clearSelectedLevel() {
    ["kpiUser", "kpiMode"].forEach((key) => this.remove(key, { path: "/" }));
  }
}

export default CookiesServices;
